import { useEffect, useState } from 'react'

function getHashPath(): string {
  const hash = window.location.hash || '#/'
  const path = hash.replace(/^#/, '')
  return path === '' ? '/' : path
}

/** Lightweight hash-based router hook. Keeps URL hash in sync with app state. */
export function useHashRoute(): [string, (path: string) => void] {
  const [path, setPath] = useState<string>(getHashPath())

  useEffect(() => {
    const onHashChange = () => setPath(getHashPath())
    window.addEventListener('hashchange', onHashChange)
    return () => window.removeEventListener('hashchange', onHashChange)
  }, [])

  const navigate = (nextPath: string) => {
    if (window.location.hash !== `#${nextPath}`) {
      window.location.hash = nextPath
    } else {
      setPath(nextPath)
    }
  }

  return [path, navigate]
}

/** Standalone navigation helper usable outside the hook, e.g. in event handlers. */
export function navigateTo(nextPath: string): void {
  window.location.hash = nextPath
}
